// Stoplicht-status per project (zes productiemomenten) — gedeeld tussen
// 'Overzicht per project' en de Projecten-lijstweergave. De kleuren/details
// komen uit POST /api/v1/planning/project-status (engine, PG-mirror);
// definities aanscherpen gebeurt dáár (project_status.py), niet hier.
import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { AI_ENGINE_URL } from '../utils/apiConfig';
import { authFetch } from '../utils/authHelpers';

export const STOPLICHT_CHECKS = [
  ['prepro', 'Preproductietaken ingepland'],
  ['crew', 'Crew bepaald'],
  ['draaidag', 'Draaidag ingepland'],
  ['productie', 'Productie voorbereid'],
  ['callsheet', 'Callsheet gemaakt'],
  ['post', 'Postproductietaken ingepland'],
];

export const STOPLICHT_KLEUR = { groen: '#22c55e', oranje: '#f59e0b', rood: '#ef4444', grijs: '#cbd5e1' };

export function StoplichtRij({ status, size = 11 }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: `${Math.max(2, Math.round(size * 0.45))}px`, flexShrink: 0 }}
      onClick={(e) => e.stopPropagation()}>
      {STOPLICHT_CHECKS.map(([key, label]) => {
        const st = status?.[key];
        const kleur = STOPLICHT_KLEUR[st?.kleur] || '#e2e8f0';
        return (
          <Tooltip key={key} title={st ? `${label}: ${st.detail}` : label} arrow>
            <Box sx={{ width: size, height: size, borderRadius: '50%', bgcolor: kleur,
              border: '1px solid rgba(0,0,0,0.08)', cursor: 'default' }} />
          </Tooltip>
        );
      })}
    </Box>
  );
}

// Batch-ophalen (max 60 per request); geeft { recId: status|null } terug.
export async function fetchProjectStatussen(ids, { stil = false } = {}) {
  const uit = {};
  for (let i = 0; i < ids.length; i += 60) {
    const chunk = ids.slice(i, i + 60);
    try {
      const r = await authFetch(`${AI_ENGINE_URL}/api/v1/planning/project-status`, {
        stil,
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ project_ids: chunk }),
      });
      const d = r.ok ? await r.json() : null;
      chunk.forEach((id) => { uit[id] = d?.status?.[id] || null; });
    } catch {
      chunk.forEach((id) => { uit[id] = null; });
    }
  }
  return uit;
}
